import React from 'react'

import { ChevronUpDownSvg } from '@src/components/adgroup-svg/react'

interface ComparablePropertyItemHeaderProps {
  labelPrefix?: string
  propertyName?: string
  areaChangerIsActive?: boolean
  propertyChangerIsActive?: boolean
  onPropertyChangerActionClick?: () => void
  onAreaChangerActionClick?: () => void
  hidePropertyChangerAction?: boolean
  hideAreaChangerAction?: boolean
  highlightAreaChanger?: boolean
  highlightPropertyChanger?: boolean
}

function ComparablePropertyItemHeader({
  labelPrefix = '',
  propertyName,
  areaChangerIsActive,
  propertyChangerIsActive,
  onPropertyChangerActionClick,
  onAreaChangerActionClick,
  hidePropertyChangerAction,
  hideAreaChangerAction,
  highlightAreaChanger,
  highlightPropertyChanger,
}: ComparablePropertyItemHeaderProps) {
  return (
    <div className="flex items-center justify-between text-neutralColour">
      {propertyName ? (
        <p
          className={`m-0 text-title font-medium leading-none ${propertyChangerIsActive || areaChangerIsActive ? 'opacity-30' : ''}`}
        >
          {labelPrefix}
          {propertyName}
        </p>
      ) : null}

      <div className="ml-auto flex items-center gap-3">
        {hideAreaChangerAction ? null : (
          <button
            className={`rounded-[5px] ${highlightAreaChanger ? 'bg-black/20' : 'bg-black/10'}`}
            onClick={onAreaChangerActionClick}
            type="button"
          >
            <ChevronUpDownSvg />
          </button>
        )}
        {hidePropertyChangerAction ? null : (
          <button
            className={`rounded-[5px] ${highlightPropertyChanger ? 'bg-black/20' : 'bg-black/10'}`}
            onClick={onPropertyChangerActionClick}
            type="button"
          >
            <ChevronUpDownSvg />
          </button>
        )}
      </div>
    </div>
  )
}

export default ComparablePropertyItemHeader
